import { stumble } from '@ipfabric/frontend-shared-assets/utils/stumble/stumble';
import { plainSet } from '@ipfabric/utils/fp/plainSet';
import { deselectAllNodes } from 'components/Graph/commands/deselectAllNodes';
import { performUndoableAction } from 'components/Graph/commands/history/performUndoableAction';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import { pipe } from 'fp-ts/lib/function';
import { clearSharedView } from '../helpers/clearSharedView';
import { makeUpdateNodesVisibility } from '../helpers/updateNodesVisibility';
import { selectPathLookupApplied } from '../model/selectors/graphMetadata/selectPathLookupApplied';

export const hideSelectedNodes: GraphCommandFactory =
  (cmdContext, dispatch) => () => {
    if (selectPathLookupApplied(cmdContext.getState())) {
      stumble('Hiding selected nodes is not allowed for Path-lookup');
      return;
    }
    cmdContext.updateState(clearSharedView);
    const { peekingAtHiddenNodes } = cmdContext.getState();
    pipe(
      cmdContext.getState().graph.selectedNodeIds,
      plainSet.toArray,
      (nodeIdsToHide) => {
        if (!cmdContext.getState().peekingAtHiddenNodes) {
          dispatch(deselectAllNodes);
        }

        dispatch(performUndoableAction, {
          undo: makeUpdateNodesVisibility(
            cmdContext.updateState,
            nodeIdsToHide,
            true,
            peekingAtHiddenNodes,
          ),
          redo: makeUpdateNodesVisibility(
            cmdContext.updateState,
            nodeIdsToHide,
            false,
            peekingAtHiddenNodes,
          ),
        });
      },
    );
  };
